import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useUpdateOrganization = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const updateOrganizationHook = async (organization, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.put(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-event-organization/v1/update/`,
        {organization}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to update organization");
      }
      
    } catch (error) {
      setError("An error occurred while updating the organization");
    } finally {
      setLoading(false);
    }
  };

  return [ updateOrganizationHook, loading, error, success ];
};